import queryClient from '@/queries/queryClient';
import * as actionTypes from '../actions';
import { USERS_KEY } from '@/queries/users/hooks';


const initialState = {
    user: { id: null, first_name: "", last_name: "", email: "", phone: "" },
    token: null,
    expiration: null,
    loading: false,
    error: null,

    logoutLoading: false,
    logoutError: null,

    resetPasswordEmailLoading: false,
    resetPasswordEmailError: null,

    resetPasswordConfirmLoading: false,
    resetPasswordConfirmError: null,

    connectedUserLoading: false,
    connectedUserError: null,
    
    isUserAuthenticated: null,

    userSettings: { id: null, first_name: "", last_name: "", email: "", phone: "" },
    getUserSettingsLoading: false,
    getUserSettingsError: false,
    updateUserSettingsLoading: false,
    updateUserSettingsError: false,

    updateUserPasswordLoading: false,
    updateUserPasswordError: false,
};

const authenticationReducer = (state = initialState, action) => {
    switch (action.type) {

        // LOGIN
        case actionTypes.LOGIN_REQUEST:
            return {
                ...state,
                loading: action.loading
            };
        case actionTypes.LOGIN_SUCCESS:
            return {
                ...state,
                loading: action.loading,
                error: action.error,
                token: action.payload.token,
                expiration: action.payload.expiration,
                user: action.payload.user,
                isUserAuthenticated: true,
            };
        case actionTypes.LOGIN_ERROR:
            return {
                ...state,
                loading: action.loading,
                error: action.error
            };

        // LOGOUT
        case actionTypes.LOGOUT_REQUEST:
            return {
                ...state,
                logoutLoading: action.loading
            };
        case actionTypes.LOGOUT_SUCCESS:
            return {
                ...state,
                logoutLoading: action.loading,
                logoutError: action.error,
                token: null,
                expiration: null,
                user: { id: null, first_name: "", last_name: "", email: "", phone: "" },
                isUserAuthenticated: false,
            };
        case actionTypes.LOGOUT_ERROR:
            return {
                ...state,
                logoutLoading: action.loading,
                logoutError: action.error
            };

        // RESET PASSWORD USER
        case actionTypes.RESET_PASSWORD_EMAIL_REQUEST:
            return {
                ...state,
                resetPasswordEmailLoading: action.loading
            };
        case actionTypes.RESET_PASSWORD_EMAIL_SUCCESS:
            return {
                ...state,
                resetPasswordEmailLoading: action.loading,
                resetPasswordEmailError: action.error
            };
        case actionTypes.RESET_PASSWORD_EMAIL_ERROR:
            return {
                ...state,
                resetPasswordEmailLoading: action.loading,
                resetPasswordEmailError: action.error
            };

        // RESET PASSWORD CONFIRM
        case actionTypes.RESET_PASSWORD_CONFIRM_REQUEST:
            return {
                ...state,
                resetPasswordConfirmLoading: action.loading
            };
        case actionTypes.RESET_PASSWORD_CONFIRM_SUCCESS:
            return {
                ...state,
                resetPasswordConfirmLoading: action.loading,
                resetPasswordConfirmError: action.error
            };
        case actionTypes.RESET_PASSWORD_CONFIRM_ERROR:
            return {
                ...state,
                resetPasswordConfirmLoading: action.loading,
                resetPasswordConfirmError: action.error
            };

        // CONNECTED USER
        case actionTypes.GET_CONNECTED_USER_REQUEST:
            return {
                ...state,
                connectedUserLoading: action.loading
            };
        case actionTypes.GET_CONNECTED_USER_SUCCESS:
            return {
                ...state,
                connectedUserLoading: action.loading,
                connectedUserError: action.error,
                isUserAuthenticated: true,
            };
        case actionTypes.GET_CONNECTED_USER_ERROR:
            return {
                ...state,
                connectedUserLoading: action.loading,
                connectedUserError: action.error,
                isUserAuthenticated: false,
            };

        // GET USER SETTINGS
        case actionTypes.GET_USER_SETTINGS_REQUEST:
            return {
                ...state,
                getUserSettingsLoading: action.loading
            };
        case actionTypes.GET_USER_SETTINGS_SUCCESS:
            return {
                ...state,
                getUserSettingsLoading: action.loading,
                getUserSettingsError: action.error,
                userSettings: action.userSettings
            };
        case actionTypes.GET_USER_SETTINGS_ERROR:
            return {
                ...state,
                getUserSettingsLoading: action.loading,
                getUserSettingsError: action.error
            };

        // UPDATE USER SETTINGS
        case actionTypes.UPDATE_USER_SETTINGS_REQUEST:
            return {
                ...state,
                updateUserSettingsLoading: action.loading
            };
        case actionTypes.UPDATE_USER_SETTINGS_SUCCESS:
            // Legacy adaptation
            queryClient.invalidateQueries({ queryKey: [USERS_KEY,], });
            return {
                ...state,
                updateUserSettingsLoading: action.loading,
                updateUserSettingsError: action.error,
                userSettings: action.userSettings
            };
        case actionTypes.UPDATE_USER_SETTINGS_ERROR:
            return {
                ...state,
                updateUserSettingsLoading: action.loading,
                updateUserSettingsError: action.error
            };

        // UPDATE USER PASSWORD
        case actionTypes.UPDATE_USER_PASSWORD_REQUEST:
            return {
                ...state,
                updateUserPasswordLoading: action.loading
            };
        case actionTypes.UPDATE_USER_PASSWORD_SUCCESS:
            return {
                ...state,
                token: action.payload.token,
                expiration: action.payload.expiration,
                updateUserPasswordLoading: action.loading,
                updateUserPasswordError: action.error,
            };
        case actionTypes.UPDATE_USER_PASSWORD_ERROR:
            return {
                ...state,
                updateUserPasswordLoading: action.loading,
                updateUserPasswordError: action.error
            };
        
        default:
            return state;
    }
};

export default authenticationReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/authentication.js